// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6e78cc88","453":"cddf7d16","455":"8bc8965c","977":"9f35b5d7"}[chunkId] + ".chunk.js";
};